import React, { useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";

import ColdStorageKg from "../../../images/material_orange.svg";

import KgEntered from "../../../images/material_kg.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import Button from "../../../components/shared/buttons/button";
import BrokerageSortinModal from "./BrokerageSortinModal";
import {
  useGetBrokerageMaterialQuery,
  useGetBrokerageSummaryQuery,
} from "../materialEntered/materialApi";
import { formatDateAndTimeFromUTC } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
const BrokerageSorting = () => {
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [page, setPage] = useState(1);
  const [addMaterial, setAddMaterial] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { data: brokerageMaterial, refetch: refetchMaterial } = useGetBrokerageMaterialQuery({
    status: ["sorting", "packaging"],
  });
  const { data: summaryData, refetch: refetchSummary } = useGetBrokerageSummaryQuery({
    date,
    tab: "sorting",
  });
  const handleEdit = (unloading) => {
    setAddMaterial(true);
    setModalMode("edit");
    setSelectedMaterial(unloading);
    setShowModal(true);
  };
  const listItems = [
    {
      label: _t("kg_entered_in_sorting", "KG Entered in Sorting"),
      value: summaryData?.kg_entered_in_sorting,
      icon: ColdStorageKg,
    },
    {
      label: _t("kg_selected", "KG Selected"),
      value: summaryData?.kg_selected,
      icon: KgEntered,
    },
    {
      label: _t("kg_rejected", "KG Rejected"),
      value: summaryData?.kg_rejected,
      icon: ColdStorageKg,
    },
  ];

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleSaved = () => {
    refetchMaterial();
    refetchSummary();
  };

  const columns = [
    {
      label: _t("date", "Date"),
      accessor: "sorting_date",
      cell: ({ value }) => {
        return formatDateAndTimeFromUTC(value).date;
      },
    },
    {
      label: _t("time", "Time"),
      accessor: "sorting_date",
      cell: ({ value }) => {
        return formatDateAndTimeFromUTC(value).time;
      },
    },
    { label: _t("supplier_name", "Supplier Name"), accessor: "supplier_name" },
    { label: _t("total_kg", "Total KG"), accessor: "total_entered_kg" },
    { label: _t("selected_kg", "Selected KG"), accessor: "total_selected_kg" },
    {
      label: _t("selected_cheeks", "Selected Cheeks"),
      accessor: "selected_cheeks_kg",
    },
    {
      label: _t("selected_strips", "Selected Strips"),
      accessor: "selected_stripe_kg",
    },
    { label: _t("rejected_kg", "Rejected KG"), accessor: "rejected_kg" },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span
          className={value === "sorting" ? "cmn_badge inactive" : "cmn_badge"}
        >
          {value === "sorting"
            ? _t("sorting", "Sorting")
            : _t("ready_for_packing", "Ready for Packing")}
        </span>
      ),
    },

    {
      label: _t("edit_view", "Edit/View"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          <Button
            size="small"
            label={
              row.status === "sorting"
                ? _t("edit", "Edit")
                : _t("sorted", "Sorted")
            }
            className={row.status === "sorting" ? "" : "borderRedBtn"}
            onClick={() => handleEdit(row)}
            disabled={row.status !== "sorting"}
          />
        </>
      ),
    },
  ];
  return (
    <div>
      {addMaterial && (
        <BrokerageSortinModal
          show={showModal}
          setShow={setAddMaterial}
          mode={modalMode}
          unloading={selectedMaterial}
          onSuccess={handleSaved}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("sorting_overview", "Sorting Overview")}
          </h6>

          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <Datatable
        title={_t("sorting_log", "Sorting Log")}
        columns={columns}
        tableData={brokerageMaterial?.data}
        pagination
        page={page}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default BrokerageSorting;
